//判断是否是手机号
window.is_phone = function (phone) {
    if (typeof (phone) != 'string') {
        phone = phone.toString()
    }
    if (phone.length == 11) {
        return /1(3[0-9]|4(1|[4-9])|5((?!4)[0-9])|6[0-9]|7(0|1|[3-8])|8[0-9]|9[0-9])\d{8,8}/.test(phone)
    } else {
        return false
    }
}


window.countDown = function (endTime, func) {
    let date = [{
        date: '07',
        text: '天'
    },
    {
        date: '07',
        text: '时'
    },
    {
        date: '07',
        text: '分'
    },
    {
        date: '07',
        text: '秒'
    }
    ];
    var time = endTime * 1000;
    var nowTime = Date.now();
    var timediff = Math.round((time - nowTime) / 1000);
    function t(d) {
        if (d < 10) {
            if (d >= 1) {
                return '0' + d
            } else {
                return '00'
            }
        } else {
            return d
        }
    }
    //获取还剩多少天
    date[0].date = t(parseInt(timediff / 3600 / 24))
    //获取还剩多少小时
    date[1].date = t(parseInt((timediff / 3600) % 24))
    //获取还剩多少分钟
    date[2].date = t(parseInt((timediff / 60) % 60))
    //获取还剩多少秒
    date[3].date = t(timediff % 60);

    //输出还剩多少时间
    if (timediff >= 0) {
        func({ code: timediff == 0 ? -1 : 200, data: date });
    } else {
        func({ code: -1, data: date });
    }
}

window.setCookie = function (name, value, day) {

    if (day !== 0) { //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        var d = new Date();
        d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + escape(value) + ";expires=" + d.toGMTString() + "; path=/;";
    } else {
        document.cookie = name + "=" + escape(value) + "; path=/;";
    }
}

window.getCookie = function (name) {
    var arr;
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
    ocument.cookie = name + "=" + escape(value);
}
window.is_weixn = function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}
window.is_ios = function () {
    const agent = navigator.userAgent
    return !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
}

window.shareShow = function () {
    if (!is_weixn()) {
        return
    }
    function onBridgeReady() {
        WeixinJSBridge.call('showOptionMenu');
    }
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady();
    }
}
window.shareHide = function () {
    if (!is_weixn()) {
        return
    }
    function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
    }
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady();
    }
}


window.getUser_id = function (app_id_) {
    let user_id = JSON.parse(localStorage.getItem("user_id"));
    let app_id = app_id_ || localStorage.getItem("app_id");
    if (user_id != null && typeof (user_id) == "object") {
        return user_id[app_id]
    }
    else {
        return localStorage.getItem("user_id")
    }
}


window.addUser_id = function (obj2) {
    let obj1 = JSON.parse(localStorage.getItem("user_id"));
    if (obj1 != null && typeof (obj1) == "object") {
        for (var key in obj2) {
            obj1[key] = obj2[key];
        }
        return obj1;
    } else {
        return obj2;
    }
}


window.objMerge = function (obj1, obj2) {
    if (obj1 != null && typeof (obj1) == "object") {
        for (var key in obj2) {
            obj1[key] = obj2[key];
        }
        return obj1;
    } else {
        return obj2;
    }
}
window.is_android = function () {
    const agent = navigator.userAgent
    return agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1;
}


// 解密
window.AesCbcDecrypt = function (text, iv, key) {
    let decrypted = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
}

window.getToken = function (app_id_) {
    let token = JSON.parse(localStorage.getItem("token"));
    let app_id = app_id_ || localStorage.getItem("app_id");
    if (token != null && typeof (token) == "object") {
        return token[app_id]
    }
    else {
        return undefined
    }
}

let sign = {
    'westernmd_1011': 'fbd23c939d16bc9ec8eb45c6267073c8',
    'wpractitioner_0109': '1affbe875df596adf8c888a1e28e5039',
    'tcm_0223': '9ed4ccaff8ac01392179d5a617a1470b',
    'mptcm_0305': 'db7e95f9e2970bfc9dd0800e4cbd897f',
    'oral_0322': '2372b12f1b8498d134b5a3fc23c9d584',
    'pharmic_0425': 'f02d5c165e589c24561602370e828627',
    'hulizhiyezige_0411': '0fb684a0677332f23ec8bdf8de9194a0',
    'health_0920': '0906ae380b8a5b9783dd3bc9c4bd9f48',
    'letiku_0725': '857d7308d8f8823f8505a177f2bc2eb7',
}

window.getSign = function (obj) {
    let keys = Object.keys(obj).sort();
    let s = ''
    for (let key of keys) {
        if (obj[key]) {
            s += `${key}=${obj[key]}`
        }
    }
    let app_id = localStorage.getItem("app_id");
    let signS = sign[app_id]
    if (signS) {
        s += signS
    }
    return hex_md5(s)
}

window.merge_materials_list = function (list1, list2) {
    if (Array.isArray(list1))
        for (let e of list1) {
            for (let item of list2) {
                if (item.materials_id == e.materials_id) {
                    item.materials_title = e.materials_title;
                    item.materials_title_img_url = e.materials_title_img_url;
                }
            }
        }
    return list2;
}


window.removeKeepAliveCache = function () {
    if (this.$vnode && this.$vnode.data.keepAlive && this.$vnode.parent) {
        const tag = this.$vnode.tag;
        let caches = this.$vnode.parent.componentInstance.cache;
        let keys = this.$vnode.parent.componentInstance.keys;
        for (let [key, cache] of Object.entries(caches)) {
            if (cache.tag === tag) {
                if (keys.length > 0 && keys.includes(key)) {
                    keys.splice(keys.indexOf(key), 1);
                }
                delete caches[key];
            }
        }
    }
    this.$destroy();
};


window.img_b = function (s) {
    if (typeof s == "string")
        s = s.replace(/[.]jpg|[.]png/gi, (e1, e2) => {
            return `_b${e1}`;
        });
    return s;
}

window.aesCbc = function (s, iv, key) {
    return CryptoJS.AES.encrypt(s, CryptoJS.enc.Utf8.parse(key), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    }).toString();
}

window.mob = function (data) {
    if (data.mob) {
        console.log(aesCbc(data.mob, `lanjiyin20500723`, `lanjiyin20500723`))
        data.mob = aesCbc(data.mob, `lanjiyin20500723`, `lanjiyin20500723`)
    }
}


Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份 
        "d+": this.getDate(),                    //日 
        "h+": this.getHours(),                   //小时 
        "m+": this.getMinutes(),                 //分 
        "s+": this.getSeconds(),                 //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds()             //毫秒 
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
    }
    return fmt;
}
window.getQuery = function (text) {
    var query = text;
    if (text[0] == "?") {
        query = text.substring(1)
    }
    var vars = query.split("&");
    var data = {}
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        data[pair[0]] = pair[1]

    }
    return data;
}
window.setStorageItem = function (key, data) {
    localStorage.setItem(key, JSON.stringify(data))
}
window.getStorageItem = function (key) {
    return JSON.parse(localStorage.getItem(key))
}



window.getSelect_list = function (item) {
    let appId = item.app_id;
    let app_type = item.app_type;
    let select_list = getStorageItem(`${appId}${app_type}select_list`);
    if (select_list) {
        item.classificationTabIndex = select_list[3];
        if (item.classificationTabIndex == 1) {
            item.is_high_select = 1;
        }
        if (item.classificationTabIndex == 2) {
            item.is_vod_select = 1;
        }
        if (item.classificationTabIndex == 3) {
            item.is_case_vod_select = 1;
        }
        if (typeof select_list[0] == "number") {
            let list = ["", "", 5, 10, 12, 15, 20, 25, -3, -5];
            item.year_select = list[select_list[0]] || "";
            item.yearTabIndex = select_list[0];
        } else {
            item.max_min_year_select = select_list[0].value;
            item.year_select = "";
            item.yearTabIndex = 1;
        }
    } else {
        item.yearTabIndex = 0;
        item.classificationTabIndex = 0;
        item.year_select = "";
        item.max_min_year_select = "";
        item.is_vod_select = false;
        item.is_high_select = false;
        item.is_case_vod_select = false;
        item.is_updata = false;
    }
    return item
}

// 题库首页_学科真题	lanjiyin://Event?event_code=jump_tiku_home&is_login=0　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　
// 题库首页_章节组题	lanjiyin://Event?event_code=jump_tiku_home&is_login=0
// 题库首页_年份真题	lanjiyin://Event?event_code=jump_tiku_home&is_login=0
// 题库首页_必背考点	lanjiyin://Event?event_code=jump_tiku_home&is_login=0
// 题库首页_随机组题	lanjiyin://Event?event_code=jump_tiku_home&is_login=0
// 题库首页_院校	lanjiyin://Event?event_code=jump_tiku_home&is_login=0
// 题库首页_每日一练	lanjiyin://Event?event_code=jump_tiku_home&is_login=0


// 题库我的错题页	lanjiyin://Router?class_name=/online/WrongQuestionActivity&is_login=1
// 题库我的笔记页	lanjiyin://Router?class_name=/online/NoteActivity&is_login=1
// 题库我的收藏页	lanjiyin://Router?class_name=/online/CollectionActivity&is_home=1&is_login=1
// 题库我的评论页	lanjiyin://Router?class_name=/my/MyCommentActivity&where_from=0&is_login=1

// 题库首页_题单列表	lanjiyin://Event?event_code=jump_tiku_sheet&is_login=0

// 题单介绍	lanjiyin://Router?class_name=/module_tiku/TiKuSheetDetailsActivity&is_login=1&sheet_type=题单id对应的sheet_type&is_level=题单id对应的is_level&sheet_id=题单id
// 题单合集页	lanjiyin://Router?class_name=/online/MockaoGroupActivity&is_login=1&category_id=1
// 课程首页_我的课程	lanjiyin://Event?event_code=jump_my_course&is_login=0
// 课程首页_课程分类	lanjiyin://Event?event_code=jump_course_list&is_login=0

// 课程商品详情页	lanjiyin://Router?class_name=/course/CourseBuyActivity&is_login=0&cate_id=143&service_id=1&is_shop=1
// 商城首页	lanjiyin://Event?event_code=jump_shop_list&is_login=0
// 商品详情页	lanjiyin://Router?class_name=/find/ShopDetailActivity&is_shop=1&is_login=0&goods_id=商品id
// 我的首页	lanjiyin://Event?event_code=jump_person_center&is_login=0
// 圈子首页	lanjiyin://Event?event_code=jump_forum_circle&is_login=0
// 经验首页	lanjiyin://Event?event_code=jump_experience_list&is_login=0
// 帖子详情页	lanjiyin://Router?class_name=/module_forum/CircleItemDetailsActivity&is_login=1&circle_id=帖子id
// 经验详情页	lanjiyin://Router?class_name=/module_forum/ExperienceItemDetailsActivity&is_login=1&experience_id=经验id
// 直播间页	lanjiyin://CourseLive?is_login=1&rooms_id=直播间Id
// 复试	lanjiyin://Router?class_name=/module_fushi/FuShiHomeActivity&is_login=1
window.advertPush = function (item) {
    function showToast(message) {
        vant.Toast(message || '网页暂不支持，请下载蓝基因App！');
    }
    let query = getQuery(item.and_url.split('?')[1])
    console.log(query)
    if (item.type == 1) {
        let url = item.and_url.replace("lanjiyin://Router", "");
        if (/MockaoGroupActivity/.test(url)) {
            this.$router.push(
                `/h5/Retest/Collection${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            // 题单合集
            return
        }
        if (/CustomsClearanceTextbooksActivity/.test(url)) {
            this.$router.push(
                `/h5/tiDan/clearance${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            // 通关教材
            return
        }

        if (/DaKaRiLiActivity/.test(url)) {
            this.$router.push(
                `/h5/DaKaRiLi/index${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            return
            // 打卡日历
            // showToast();
        }
        if (/miniProgram/.test(url)) {
            if (!is_weixn()) {
                showToast("");
                return
            }
            let data = query
            data.show = true
            this.$store.commit('event/setLaunchWeapp', data)
            // 打开小程序
            // showToast();
            return
        }
        if (/module_fushi\/ChuShiCJActivity/.test(url)) {
            // 复试排名
            this.$router.push(
                `/h5/Retest/rankingHome${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            return
        }
        if (/module_tiku\/TiKuSheetDetailsActivity/.test(url)) {
            // 复试排名
            this.$router.push(
                `/h5/tiDan/tiDan${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            return
        }

        if (/module_fushi/.test(url)) {
            // 复试指导
            // showToast();
            // return;
            this.$router.push(
                `/h5/Retest/index${item.and_url.replace(
                    "lanjiyin://Router",
                    ""
                )}`
            );
            return
        }
        // 商品详情页	lanjiyin://Router?class_name=/find/ShopDetailActivity&is_shop=1&is_login=0&goods_id=商品id
        if (/CourseBuyActivity/.test(url)) {
            this.$router.push({
                path: "/h5/goods",
                query: {
                    goods_id: query.goods_id,
                    app_id: localStorage.getItem("app_id"),
                    app_type: localStorage.getItem("app_type"),
                    is_shop: query.is_shop,
                    bundle_id: "lanjiyin",
                    is_merge: 1,
                },
            });
            return
        }
        // 课程商品详情页	lanjiyin://Router?class_name=/course/CourseBuyActivity&is_login=0&cate_id=143&service_id=1&is_shop=1
        if (/CourseBuyActivity/.test(url)) {
            this.$router.push({
                path: "/h5/goods",
                query: {
                    goods_id: query.service_id,
                    app_id: localStorage.getItem("app_id"),
                    app_type: localStorage.getItem("app_type"),
                    cate_id: query.cate_id,
                    is_shop: query.is_shop,
                    bundle_id: "lanjiyin",
                    is_merge: 1,
                },
            });
            return
        }
        // 课程首页_我的课程	lanjiyin://Event?event_code=jump_my_course&is_login=0
        // 课程首页_课程分类	lanjiyin://Event?event_code=jump_course_list&is_login=0
        if (/jump_my_course/.test(url)) {
            showToast();
            return
            sessionStorage.setItem("indexTab", 'coures');
            location.href = `/h5/index/index?tab=coures&tabIndex=1`
            return
        }
        if (/jump_course_list/.test(url)) {
            showToast();
            return
            sessionStorage.setItem("indexTab", 'coures');
            location.href = `/h5/index/index?tab=coures&tabIndex=0`
            return
        }
        // 题库我的错题页	lanjiyin://Router?class_name=/online/WrongQuestionActivity&is_login=1
        // 题库我的笔记页	lanjiyin://Router?class_name=/online/NoteActivity&is_login=1
        // 题库我的收藏页	lanjiyin://Router?class_name=/online/CollectionActivity&is_home=1&is_login=1
        // 题库我的评论页	lanjiyin://Router?class_name=/my/MyCommentActivity&where_from=0&is_login=1
        if (/WrongQuestionActivity/.test(url)) {
            this.$router.push({
                path: "/h5/tiku/cuoti",
            });
            return
        }
        if (/NoteActivity/.test(url)) {
            this.$router.push({
                path: "/h5/tiku/biji",
            });
            return
        }
        if (/CollectionActivity/.test(url)) {
            this.$router.push({
                path: "/h5/tiku/shoucang",
            });
            return
        }
        if (/MyCommentActivity/.test(url)) {
            this.$router.push({
                path: "/h5/tiku/pinglun",
            });
            return
        }
        if (/jump_tiku_home/.test(url)) {
            sessionStorage.setItem("indexTab", 'tiku');
            location.href = `/h5/index/index?tab=tiku`
            return
        }
        if (/jump_tiku_sheet/.test(url)) {
            sessionStorage.setItem("indexTab", 'tiku');
            location.href = `/h5/index/index?tab=tiku`
            return
        }
        // 我的首页	lanjiyin://Event?event_code=jump_person_center&is_login=0
        if (/jump_person_center/.test(url)) {
            sessionStorage.setItem("indexTab", 'my');
            location.href = `/h5/index/index?tab=my`
            return
        }
        if (/jump_shop_list/.test(item.and_url)) {
            sessionStorage.setItem("indexTab", 'shop');
            location.href = `/h5/index/index${item.and_url.replace(
                "lanjiyin://Event",
                ""
            )}&tab=shop`
            return
        }

        if (/CourseLive/.test(url)) {
            // 直播
            showToast();
            return
        }
        if (/ExperienceItemDetailsActivity/.test(url)) {
            // 论坛
            showToast();
            return
        }
        showToast();
        return;
    } else if (item.type == 2) {
        if (/app\/power/.test(item.and_url)) {
            this.$router.push({
                path: "/h5/power",
                query
            }
            );
            return
        }
        if (/h5\/getCoupon/.test(item.and_url)) {
            this.$router.push({
                path: "/h5/getCoupon",
                query
            }
            );
            return
        }
        // location.href = item.and_url;
        window.open(item.and_url)
    } else {
        showToast();
    }
}
window.pushExam = function (list, data) {
    if (list) {
        this.$store.commit("topic/settiList", list);
    }
    this.$router.push({
        path: "/h5/tiku/topic",
        query: data
    });
}


window.pushOneTi = function (list, data) {
    if (list) {
        this.$store.commit("topic/setOneTi", list);
        sessionStorage.setItem("updatetiList", 1);
    }
    this.$router.push({
        path: "/h5/tiku/topic",
        query: data,
    });
}



window.copyFunc = function (message) {
    var input = document.createElement("input");
    input.value = message;
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    document.execCommand("Copy");
    document.body.removeChild(input);
    this.$toast.center("复制成功");
}


window.lockTap = function (item) {
    //    "unlock_type": "0",#免费解锁类型（ 10:客服微信 20:邀请注册  30:公众号 40:购买  50:购买或邀请  60:购买或关注公众号）
    if ((item.unlock_type == 40 || item.is_pay == 1 || item.unlock_type == 1) && item.service_id != 0) {
        let goods_id = item.service_id
        if (typeof item.service_id == "string") {
            goods_id = item.service_id.split(",")[0]
        }
        this.$router.push({
            path: "/h5/goods",
            query: {
                goods_id: goods_id,
                app_id: localStorage.getItem("app_id"),
                app_type: localStorage.getItem("app_type"),
                bundle_id: "lanjiyin",
                is_merge: 1,
                is_shop: 1
            }
        })
    } else if (item.service_id == 0) {
        this.$toast.center("web端暂不支持解锁，请前往APP")
    } else {
        this.$toast.center("web端暂不支持解锁，请前往APP")
    }
}


window.StringToNumber = function (obj) {
    if (typeof obj == "object")
        for (let key in obj) {

            if (!obj.hasOwnProperty(key)) return;
            //排除掉原型继承而来的属性 
            if (typeof obj[key] == "string") {
                if (!(key == "price_range" || key == "content" || key == "blanks_answer")) {
                    if (obj[key].length > 0 && !isNaN(obj[key])) {
                        obj[key] = Number(obj[key])
                    }
                }
            }
            if (typeof obj[key] == 'object' || typeof obj[key] == 'function') {
                StringToNumber(obj[key]);
                //递归遍历属性值的子属性
            }
        }
}


function indexOf(list, func) {
    for (var i = 0; i < list.length; i++) {
        if (func(list[i])) return i;
    }
    return -1;
};
window.list_Remove = function (list, func) {
    var index = indexOf(list, func);
    if (index > -1) {
        list.splice(index, 1);
    }
};

function replayObj(list, i) {
    let obj = list[i];
    if (list.length == i) {
        return null;
    } else {
        if (i < 3) {
            obj.is_arr = false;
            obj.data = replayObj(list, ++i);
        } else {
            obj = {};
            obj.is_arr = true;
            obj.list = list.slice(i).reverse();
        }
    }
    return obj;
}
function replayObj2(list, i) {
    let obj = list[i];
    if (obj && obj.i == 2) {
        obj.is_showBut = true;
    }
    if (list.length == i) {
        return null;
    } else {
        if (i < 3) {
            obj.is_arr = false;
            obj.data = replayObj2(list, ++i);
        } else {
            obj = {};
            obj.is_arr = true;
            obj.list = list.slice(i).reverse();
        }
    }
    return obj;
}
window.replayInit = function (e) {
    if (e.replay.length) {
        let replay = JSON.parse(JSON.stringify(e.replay))
            .map((e, i) => {
                e.i = i;
                return e;
            })
            .reverse();
        e.replayObj = replayObj(replay, 0);

        let replay2 = JSON.parse(JSON.stringify(e.replay)).map(
            (e, i) => {
                e.i = i;
                return e;
            }
        );

        replay2.splice(3, replay2.length - 4);
        e.replayObj2 = replayObj2(replay2.reverse(), 0);

        if (e.replay.length > 4) {
            e.replayObj3 = e.replayObj2;
        } else {
            e.replayObj3 = e.replayObj;
        }

    }
    return e
}

window.unlogin = function () {
    let openid = localStorage.getItem("openid")
    let access_token = localStorage.getItem('access_token');
    localStorage.clear();
    sessionStorage.clear()
    localStorage.setItem("openid", openid)
    localStorage.setItem("loginUrl", this.$route.fullPath)
    localStorage.setItem('access_token', access_token);
    this.$router.push({
        path: "/h5/login"
    })
}


// WEBPACK FOOTER //
// ./src/public/public.js